import { render, staticRenderFns } from "./noteseditor.vue?vue&type=template&id=56264a21&scoped=true&lang=pug"
import script from "./noteseditor.vue?vue&type=script&lang=js"
export * from "./noteseditor.vue?vue&type=script&lang=js"
import style0 from "./noteseditor.vue?vue&type=style&index=0&id=56264a21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56264a21",
  null
  
)

export default component.exports